/**
 * OA 业务模块菜单配置（单一数据源）
 * 路由、权限码、侧栏菜单均由此生成
 */

export const oaModuleMenus = [
  {
    key: 'plan',
    label: '计划管理',
    icon: 'ProjectOutlined',
    sort: 27,
    children: [
      { path: '/plan/personal', label: '个人计划管理', permCode: 'oa:plan:board:personal', description: '个人待办看板与自建计划。' },
      { path: '/plan/dept', label: '部门计划管理', permCode: 'oa:plan:board:dept', description: '接收重要工作、分解子任务与部门看板。' },
      { path: '/plan/company', label: '公司计划看板', permCode: 'oa:plan:board:company', description: '全公司重要工作协作进度。' },
      { path: '/plan/major-issue', label: '公司重点事项下发', permCode: 'oa:plan:major:issue', description: '向各部门/项目下发公司重点事项。' },
      { path: '/plan/report/dept', label: '部门周月工作总结', permCode: 'oa:plan:report:dept', description: '确认并提交本周/本月工作总结。' },
      { path: '/plan/report/company', label: '周月工作总结查阅', permCode: 'oa:plan:report:company', description: '查阅各部门提交的周月工作总结。' }
    ]
  },
  {
    key: 'dept-ledger',
    label: '部门台账',
    icon: 'FileTextOutlined',
    sort: 28,
    children: [
      {
        path: '/dept-ledger/it-info',
        label: '系统问题反馈记录',
        permCode: 'oa:dept-ledger:it-info',
        description: '提交与跟踪系统问题反馈；可在角色功能权限中配置查看本人或全部数据。'
      },
      {
        path: '/dept-ledger/it-credentials',
        label: '信息部门账号密码管理',
        permCode: 'oa:dept-ledger:it-credentials',
        description: '维护公众号、抖音、邮箱等平台账号密码；进入需二次输入密码。'
      },
      {
        path: '/dept-ledger/daily-report',
        label: '日报管理',
        permCode: 'oa:dept-ledger:daily-report',
        description: '撰写当日日报并发送给部门同事，查看本人历史与收到的日报。'
      }
    ]
  },
  {
    key: 'hr',
    label: '人事管理',
    icon: 'IdcardOutlined',
    sort: 30,
    children: [
      { path: '/hr/organization', label: '组织架构管理', permCode: 'oa:hr:organization', description: '维护公司/部门/岗位树形结构，支持组织调整与历史记录。' },
      { path: '/hr/position-title', label: '岗位职级管理', permCode: 'oa:hr:position-title', description: '岗位名称与职级体系配置。' },
      { path: '/hr/onboarding', label: '入职管理', permCode: 'oa:hr:onboarding', description: '入职申请、资料收集、审批流转与入职办理。' },
      { path: '/hr/employee-archive', label: '员工档案', permCode: 'oa:hr:employee-archive', description: '员工基本信息、证件、教育经历、家庭成员等档案维护。' },
      { path: '/hr/regularization', label: '转正管理', permCode: 'oa:hr:regularization', description: '试用期转正申请、考核评价与审批。' },
      { path: '/hr/transfer', label: '人员异动管理', permCode: 'oa:hr:transfer', description: '部门/岗位调动申请、交接与审批。' },
      { path: '/hr/resignation', label: '离职管理', permCode: 'oa:hr:resignation', description: '离职申请、工作交接、资产归还与离职手续。' },
      { path: '/hr/statistics', label: '人事数据统计', permCode: 'oa:hr:statistics', description: '人员结构、入离职、编制等统计分析。' }
    ]
  },
  {
    key: 'admin',
    label: '行政管理',
    icon: 'BankOutlined',
    sort: 35,
    children: [
      { path: '/admin/company', label: '公司管理', permCode: 'oa:admin:company', description: '维护公司主体信息与常用资质证照。' },
      { path: '/admin/contract', label: '用印文件管理', permCode: 'oa:admin:contract', description: '合同类与其他用印文件的登记、审批与变更留痕。' },
      { path: '/admin/archive', label: '档案管理', permCode: 'oa:admin:archive', description: '行政档案归档、关联公司与合同。' },
      { path: '/admin/announcements', label: '通知通告', permCode: 'oa:admin:announcement', description: '发布富文本通知，通过组织架构选择下发对象。' }
    ]
  },
  {
    key: 'attendance',
    label: '考勤管理',
    icon: 'ClockCircleOutlined',
    sort: 40,
    children: [
      { path: '/attendance/records', label: '打卡记录查询', permCode: 'oa:attendance:records', description: '查看员工上下班打卡明细，支持按人/部门/日期筛选。' },
      { path: '/attendance/leave-balances', label: '假期余额', permCode: 'oa:attendance:leave-balance', description: '员工年假、调休余额查询与流水。' },
      { path: '/attendance/rules', label: '考勤规则配置', permCode: 'oa:attendance:rules', description: '班次、加班、补卡、年假、节假日、考勤组规则设置。' },
      { path: '/attendance/monthly-report', label: '月度考勤汇总报表', permCode: 'oa:attendance:monthly-report', description: '按月度汇总出勤、请假、加班、异常数据。' }
    ]
  },
  {
    key: 'salary',
    label: '工资管理',
    icon: 'AccountBookOutlined',
    sort: 50,
    children: [
      { path: '/salary/items', label: '薪资项目配置', permCode: 'oa:salary:items', description: '基本工资、绩效、补贴、扣款等薪资项目定义。' },
      { path: '/salary/formula', label: '薪资公式配置', permCode: 'oa:salary:formula', description: '各薪资项目的计算公式与规则配置。' },
      { path: '/salary/monthly-calc', label: '月度薪资核算', permCode: 'oa:salary:monthly-calc', description: '按月执行薪资核算、审核与归档。' },
      { path: '/salary/attendance-link', label: '考勤薪资自动关联', permCode: 'oa:salary:attendance-link', description: '考勤数据自动同步至薪资核算模块。' },
      { path: '/salary/adjustment', label: '奖惩薪资调整', permCode: 'oa:salary:adjustment', description: '奖励、罚款等临时性薪资调整项。' },
      { path: '/salary/payslip', label: '工资单生成与查看', permCode: 'oa:salary:payslip', description: '生成员工工资单，支持在线查看与导出。' },
      { path: '/salary/report', label: '薪资报表统计', permCode: 'oa:salary:report', description: '部门人力成本、薪资分布等统计报表。' }
    ]
  },
  {
    key: 'expense',
    label: '财务管理',
    icon: 'WalletOutlined',
    sort: 60,
    children: [
      { path: '/expense/budget/categories', label: '预算类别管理', permCode: 'oa:expense:budget:category', description: '维护预算类别及年度/季度/月度周期。' },
      { path: '/expense/budget/board', label: '预算看板', permCode: 'oa:expense:budget:board', description: '查看各组织预算、批量导入与手动维护。' },
      { path: '/expense/payees', label: '收款方管理', permCode: 'oa:expense:payee', description: '维护外部个人与供应商收款信息库。' },
      { path: '/expense/company-bank-accounts', label: '公司开户信息管理', permCode: 'oa:expense:company-bank-account', description: '维护各公司在银行的开户账号信息。' },
      { path: '/expense/bank-branches', label: '银行支行维护', permCode: 'oa:hr:bank-branch', description: '维护开户行/支行主数据，供入职、档案、报销等模块搜索使用。' },
      { path: '/expense/types', label: '费用类型配置', permCode: 'oa:expense:types', description: '差旅、交通、餐饮等费用类型与限额配置。' },
      { path: '/expense/application', label: '费用申请单', permCode: 'oa:expense:application', description: '事前费用申请与预算占用。' },
      { path: '/expense/daily', label: '费用报销', permCode: 'oa:expense:daily', description: '费用报销提交与审批。' },
      { path: '/expense/travel', label: '出差报销单', permCode: 'oa:expense:travel', description: '出差相关费用汇总报销。' },
      { path: '/expense/approval', label: '报销审批流转', permCode: 'oa:expense:approval', description: '报销单多级审批流程配置与处理。' },
      { path: '/expense/records', label: '报销记录查询', permCode: 'oa:expense:records', description: '历史报销单查询与状态跟踪。' },
      { path: '/expense/settlement', label: '已结/未结账单管理', permCode: 'oa:expense:settlement', description: '报销款项结算状态与财务对账。' },
      { path: '/expense/statistics', label: '费用支出统计', permCode: 'oa:expense:statistics', description: '部门/项目/类型维度的费用分析。' }
    ]
  },
  {
    key: 'materials',
    label: '物资管理',
    icon: 'InboxOutlined',
    sort: 70,
    children: [
      { path: '/materials/warehouses', label: '仓库管理', permCode: 'oa:materials:warehouse', description: '创建仓库并绑定职能中心或项目。' },
      { path: '/materials/products', label: '商品管理', permCode: 'oa:materials:products', description: '维护本组织商品档案与分类。' },
      { path: '/materials/inbound', label: '入库管理', permCode: 'oa:materials:inbound', description: '物资入库登记，支持转报销/预付款。' },
      { path: '/materials/outbound', label: '出库/消耗', permCode: 'oa:materials:outbound', description: '领用、消耗、损耗出库。' },
      { path: '/materials/inventory', label: '库存查询', permCode: 'oa:materials:inventory', description: '按仓库查询现存量。' },
      { path: '/materials/statistics', label: '物资统计', permCode: 'oa:materials:statistics', description: '本组织或全公司物资汇总。' }
    ]
  }
];

/** 扁平化所有业务页面 */
export const flatModulePages = oaModuleMenus.flatMap((module) =>
  module.children.map((page) => ({
    ...page,
    moduleKey: module.key,
    moduleLabel: module.label
  }))
);

/** 根据路径获取页面元信息 */
export const getPageMetaByPath = (pathname) =>
  flatModulePages.find((page) => page.path === pathname) || null;

/** 生成路由-权限映射 */
export const buildModuleRoutePermissionMap = () => {
  const map = {};
  flatModulePages.forEach((page) => {
    map[page.path] = page.permCode;
  });
  return map;
};

/** 根据路径推断应展开的一级菜单 key */
export const getOpenMenuKeysByPath = (pathname) => {
  const page = getPageMetaByPath(pathname);
  return page ? [page.moduleKey] : [];
};
